import FlintLoadingWrapper from "../page_components/common/loading/FlintLoadingWrapper";
import styles from './PreloaderComponent.module.scss'
import React, {useEffect, useState} from "react";
import FlintNotification from "../page_components/common/notifications/FlintNotification";

export default function PreloaderComponent(props: PreloaderComponentProps) {
    const {isLoading = true, loadingText = '... loading ...'} = props;
    const [text, setText] = useState<string>(loadingText);

    useEffect(() => {
        if (isLoading)
            setText("... loading ...")
        else {
            setText("...");
        }
    }, [isLoading])
    return (

        <div className={styles.preloaderWrapper}>
            <FlintLoadingWrapper loadingWrapperClassName={styles.loadingWrapper} showLoading={isLoading}>
                <FlintNotification/>
                {loadingText && <div className={styles.preloader} dangerouslySetInnerHTML={{__html: text}}></div>}
            </FlintLoadingWrapper>
        </div>
    )
}

export interface PreloaderComponentProps {
    isLoading?: boolean;
    loadingText?: string;
}